// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { NormalTraffic, NormalTrafficT, verifyNormalTraffic } from "./normal-traffic";
import {
  TrafficVariant,
  unionToTrafficVariant,
  unionListToTrafficVariant,
} from "./traffic-variant";
import { ValuedTraffic, ValuedTrafficT, verifyValuedTraffic } from "./valued-traffic";

export class ElevatorTrafficMessage implements flatbuffers.IUnpackableObject<ElevatorTrafficMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ElevatorTrafficMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsElevatorTrafficMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorTrafficMessage,
  ): ElevatorTrafficMessage {
    return (obj || new ElevatorTrafficMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsElevatorTrafficMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ElevatorTrafficMessage,
  ): ElevatorTrafficMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ElevatorTrafficMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  trafficType(): TrafficVariant {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : TrafficVariant.NONE;
  }

  traffic<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
  }

  static startElevatorTrafficMessage(builder: flatbuffers.Builder) {
    builder.startObject(3);
  }

  static addTrafficType(builder: flatbuffers.Builder, trafficType: TrafficVariant) {
    builder.addFieldInt8(0, trafficType, TrafficVariant.NONE);
  }

  static addTraffic(builder: flatbuffers.Builder, trafficOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, trafficOffset, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(2, position, 0);
  }

  static endElevatorTrafficMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // traffic
    return offset;
  }

  static createElevatorTrafficMessage(
    builder: flatbuffers.Builder,
    trafficType: TrafficVariant,
    trafficOffset: flatbuffers.Offset,
    position: number,
  ): flatbuffers.Offset {
    ElevatorTrafficMessage.startElevatorTrafficMessage(builder);
    ElevatorTrafficMessage.addTrafficType(builder, trafficType);
    ElevatorTrafficMessage.addTraffic(builder, trafficOffset);
    ElevatorTrafficMessage.addPosition(builder, position);
    return ElevatorTrafficMessage.endElevatorTrafficMessage(builder);
  }

  unpack(): ElevatorTrafficMessageT {
    return new ElevatorTrafficMessageT(
      this.trafficType(),
      (() => {
        const temp = unionToTrafficVariant(this.trafficType(), this.traffic.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
      this.position(),
    );
  }

  unpackTo(_o: ElevatorTrafficMessageT): void {
    _o.trafficType = this.trafficType();
    _o.traffic = (() => {
      const temp = unionToTrafficVariant(this.trafficType(), this.traffic.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
    _o.position = this.position();
  }

  unpackFields(...fields: string[]): ElevatorTrafficMessageT {
    const t = new ElevatorTrafficMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("traffic_type")) {
      t.trafficType = this.trafficType();
    }
    if (fieldSet.has("traffic")) {
      t.traffic = (() => {
        const temp = unionToTrafficVariant(this.trafficType(), this.traffic.bind(this));
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    return t;
  }
}

export class ElevatorTrafficMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public trafficType: TrafficVariant = TrafficVariant.NONE,
    public traffic: NormalTrafficT | ValuedTrafficT | null = null,
    public position: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.traffic === null || this.traffic === undefined) {
      throw new Error('Required field "traffic" is not set');
    }
    const traffic = builder.createObjectOffset(this.traffic);

    return ElevatorTrafficMessage.createElevatorTrafficMessage(
      builder,
      this.trafficType,
      traffic,
      this.position,
    );
  }

  clone(): ElevatorTrafficMessageT {
    const obj = new ElevatorTrafficMessageT();
    obj.trafficType = this.trafficType;
    obj.traffic =
      this.traffic !== null && typeof (this.traffic as any).clone === "function"
        ? (this.traffic as any).clone()
        : this.traffic;
    obj.position = this.position;
    return obj;
  }

  equals(other: ElevatorTrafficMessageT): boolean {
    if (this.trafficType !== other.trafficType) return false;
    if (this.traffic !== null && other.traffic !== null) {
      if (typeof (this.traffic as any).equals === "function") {
        if (!(this.traffic as any).equals(other.traffic)) return false;
      } else if (this.traffic !== other.traffic) return false;
    } else if (this.traffic !== other.traffic) return false;
    if (this.position !== other.position) return false;
    return true;
  }
}

export function verifyElevatorTrafficMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "traffic");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // NormalTraffic
            {
              const o = verifier.readInt32(pos);
              verifyNormalTraffic(verifier, pos + o);
            }
            break;
          case 2: // ValuedTraffic
            {
              const o = verifier.readInt32(pos);
              verifyValuedTraffic(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "traffic");
    verifier.checkScalarField(tablePos, 8, 2);
  } finally {
    verifier.popDepth();
  }
}
